import React, { PureComponent } from 'react';
import ReactTooltip from 'react-tooltip';
import { TextInput } from '../../atoms/TextInput';
import { Checkbox } from '../../atoms/Checkbox';
import { GreyCircle, QuestionMark } from '../../atoms/Icons';

import {
  TextComponentWrapper,
  HelperTextContainer,
  HelperText,
  HelperTextSymbol,
  FieldsContainer,
  NameFieldWrapper,
  NameFieldContainer,
  CheckboxContainer,
  ErrorMessageWrapper,
  QuestionMarkContainer,
  IconWrapper,
  ToolTipContainer,
  ToolTipWrapper,
  HelperTextContainerToolTip,
} from './elements';
import { words } from '../../../constants';
import ErrorMessage from './ErrorMessage';

type Props = {
  email: string;
  lastName: string;
  firstName: string;
  password: string;
  retypedPassword: string;
  joinMailingList: string;
  emailError: string;
  lastNameError: string;
  firstNameError: string;
  passwordError: string;
  retypedPasswordError: string;
  onChangeEmail: (text: string) => void;
  onChangeLastName: (text: string) => void;
  onChangeFirstName: (text: string) => void;
  onChangePassword: (text: string) => void;
  onChangeRetypePassword: (text: string) => void;
  onChangeJoinMailingList: (isChecked: string) => void;
};

class SignUpFormFields extends PureComponent<Props> {
  render = (): React.ReactElement => {
    const {
      email,
      lastName,
      firstName,
      password,
      retypedPassword,
      joinMailingList,
      emailError,
      lastNameError,
      firstNameError,
      passwordError,
      retypedPasswordError,
      onChangeEmail,
      onChangeFirstName,
      onChangeLastName,
      onChangePassword,
      onChangeRetypePassword,
      onChangeJoinMailingList,
    } = this.props;

    return (
      <FieldsContainer>
        <TextComponentWrapper>
          <TextInput
            cyId="signup-emailInput"
            value={email}
            placeholder={words.registration.placeholders.email}
            onChangeText={onChangeEmail}
            theme="blueBottomBorder"
          />
          <ErrorMessage
            id="signup-emailError"
            errors={emailError ? { error: emailError } : {}}
          />
        </TextComponentWrapper>
        <NameFieldContainer>
          <NameFieldWrapper>
            <TextInput
              cyId="signup-lastNameInput"
              value={lastName}
              placeholder={words.lastName}
              onChangeText={onChangeLastName}
              theme="blueBottomBorder"
            />
            <ErrorMessage
              id="signup-lastNameError"
              errors={lastNameError ? { error: lastNameError } : {}}
            />
          </NameFieldWrapper>
          <NameFieldWrapper>
            <TextInput
              cyId="signup-firstNameInput"
              value={firstName}
              placeholder={words.firstName}
              onChangeText={onChangeFirstName}
              theme="blueBottomBorder"
            />
            <ErrorMessage
              id="signup-firstNameError"
              errors={firstNameError ? { error: firstNameError } : {}}
            />
          </NameFieldWrapper>
        </NameFieldContainer>
        <TextComponentWrapper>
          <TextInput
            cyId="signup-passwordInput"
            value={password}
            placeholder={words.registration.placeholders.password}
            onChangeText={onChangePassword}
            theme="blueBottomBorder"
            type="password"
          />
          <ErrorMessageWrapper>
            <ErrorMessage
              id="signup-passwordError"
              errors={passwordError ? { error: passwordError } : {}}
            />
            <HelperTextContainer>
              <HelperTextSymbol>※</HelperTextSymbol>
              <HelperText>{words.registration.passwordRequirement}</HelperText>
            </HelperTextContainer>
            <ToolTipContainer>
              <ToolTipWrapper data-tip data-for="passwordNote">
                <IconWrapper>
                  <GreyCircle />
                </IconWrapper>
                <QuestionMarkContainer>
                  <QuestionMark />
                </QuestionMarkContainer>
              </ToolTipWrapper>
            </ToolTipContainer>
            <ReactTooltip
              id="passwordNote"
              place="left"
              effect="solid"
              backgroundColor="#B3C1E0">
              <HelperTextContainerToolTip>
                <HelperTextSymbol>※</HelperTextSymbol>
                <HelperText>
                  {words.registration.passwordRequirement}
                </HelperText>
              </HelperTextContainerToolTip>
            </ReactTooltip>
          </ErrorMessageWrapper>
        </TextComponentWrapper>
        <TextComponentWrapper>
          <TextInput
            cyId="signup-confirmPasswordInput"
            value={retypedPassword}
            placeholder={words.registration.placeholders.passwordConfirmation}
            onChangeText={onChangeRetypePassword}
            theme="blueBottomBorder"
            type="password"
          />
          <ErrorMessageWrapper>
            <ErrorMessage
              id="signup-confirmPasswordError"
              errors={
                retypedPasswordError ? { error: retypedPasswordError } : {}
              }
            />
            <ToolTipContainer>
              <ToolTipWrapper data-tip data-for="passwordNote">
                <IconWrapper>
                  <GreyCircle />
                </IconWrapper>
                <QuestionMarkContainer>
                  <QuestionMark />
                </QuestionMarkContainer>
              </ToolTipWrapper>
            </ToolTipContainer>
            <HelperTextContainer>
              <HelperTextSymbol>※</HelperTextSymbol>
              <HelperText>{words.registration.passwordRequirement}</HelperText>
            </HelperTextContainer>
          </ErrorMessageWrapper>
        </TextComponentWrapper>
        <CheckboxContainer>
          <Checkbox
            value={joinMailingList}
            onToggle={onChangeJoinMailingList}
            label={words.registration.joinMailingListLabel}
          />
        </CheckboxContainer>
      </FieldsContainer>
    );
  };
}

export default SignUpFormFields;
